var $ = require ('jquery');
var resizer = require('../lib/fullResizer');
var canvastools = require('../lib/canvas');
var template = require('../templates/success.hbs');


/**
 * Executes an array of promise factories in series.
 * @param  {Array} promiseFactories Array of promise factory functions.
 * @param  {Any} data             Data passed to first promise factory.
 * @return {Promise}              A resolved promise.
 */
function execute(promiseFactories, data) {
  var result = Promise.resolve(data);
  promiseFactories.forEach(function (promiseFactory) {
    result = result.then(promiseFactory);
  });
  return result;
}


/**
 * Builds a success view.
 * @param  {Object} options Options hash.
 * @return {Function}       Promise factory.
 */
var successFactory = function (options) {

  var defaults = {
    wrapper: "#appendHere",
    uiclasses: {
      frame: "",
      icon: "",
      number: ""
    }
  };

  defaults = Object.assign(defaults, options);

  var $wrapper = $(defaults.wrapper);
  var $html = $(template(defaults.uiclasses));
  var canvas = $html.find("#successCanvas")[0];


  /**
   * Displays rendered template
   * @param  {Element} result Dom element to append to rendered html.
   * @param  {Array}   result paper.js Path instance
   * @return {Promise}        Resolves automatically after 2 seconds.
   */
  var displaySuccessView = function (result) {
    $wrapper.html($html);
    resizer.watch(canvas);

    if (result && result.nodeName) {
      $html.append(result);
    } else if (result) {
      canvastools.drawPath(canvas, result);
    }

    setTimeout(function () {
      $wrapper.addClass('in');
    }, 250);
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        $wrapper.html('')
          .removeClass('in');
        resolve();
      }, 2000);
    });
  };

  var promises = [displaySuccessView];

  /**
   * Promise factory
   * @param  {Any} result
   * @return {Promise}
   */
  return function (result) {
    return Promise.resolve()
      .then(function () {
        return execute(promises, result);
      })
      .catch(console.log.bind(console));
  };

};

module.exports = successFactory;
